
import { httpRequest } from "@/utils/HttpRequest";
import { IPage } from "@/types/ScmTypes";
import { ISCMPurchaseDrSearch, ISCMPurchaseDrDetail, ISCMPurchaseDrStatistics, ISCMPurchaseDrInsert, ISCMPurchaseDrUpdate, ISCMPDrGoodsOne, ISCMPDrSearch, ISCMORVRMTransferSearch, ISCMORVRMTransferDetails, IVRMQuerySearch, IVRMQueryDetails } from "./purchaseDrTypes";
// import { IMdBeFields } from "@/views/organization/be/beService";
import { IVRMShopFormFields } from "@/views/organization/shop/shopService";
import { getBaseCiRequestUrl, getToken } from "@/utils/constants";

export interface ISCMPage<T, S> extends IPage<T> {
    statistics: S
}

export interface IFmsShopUnitDetail {
    bentityList: IVRMShopFormFields[],
    address: string,
    bentity: string,
    branch: string,
    branchList: string,
    code: string,
    contact: string,
    createTime: string,
    createUser: string,
    deleteFlag: string,
    enable: string,
    id: string,
    name: string,
    note: string,
    phone: string,
    shop: string,
    shopCode: string,
    shopList: string,
    shopName: string,
    status: string,
    tel: string,
    updateTime: string,
    updateUser: string,
    ver: string,
}

class PurchaseDrService {
    async page(searchVo: ISCMPurchaseDrSearch) {
        // const apiUrl = "/hd-sms/transfer/to/listPage";
        const apiUrl = "/zzw-vrm/transfer/to/listPage";
        return await httpRequest.post<IPage<ISCMPurchaseDrDetail>>(apiUrl, searchVo);
    }
    async pageStatistics(searchVo: ISCMPurchaseDrSearch) {
        // const apiUrl = "/hd-sms/transfer/to/TransferInSummary";
        const apiUrl = "/zzw-vrm/transfer/to/TransferInSummary";
        return await httpRequest.post<ISCMPurchaseDrStatistics>(apiUrl, searchVo);
    }
    async one(id: string) {
        // const apiUrl = `/hd-sms/transfer/to/findByIdOrCode/${id}`;
        const apiUrl = `/zzw-vrm/transfer/to/findByIdOrCode/${id}`;
        return await httpRequest.get<ISCMPurchaseDrDetail>(apiUrl);
    }
    async insert(insertVo: ISCMPurchaseDrInsert) {
        // const apiUrl = "/hd-sms/transfer/to/insert";
        const apiUrl = "/zzw-vrm/transfer/to/insert";
        return await httpRequest.post<any>(apiUrl, insertVo);
    }
    async update(updateVo: ISCMPurchaseDrUpdate) {
        // const apiUrl = "/hd-sms/transfer/to/update";
        const apiUrl = "/zzw-vrm/transfer/to/update";
        return await httpRequest.post<any>(apiUrl, updateVo);
    }
    //查询站点结算单位的 下属关联
    async queryShopUnitBe(shopId: string) {
        const apiUrl = `/fms/no/accountUnit/find/one/${shopId}`;
        return await httpRequest.post<IFmsShopUnitDetail>(apiUrl);
    }
    //驳回
    async reject(id: string) {
        // const apiUrl = `/hd-sms/transfer/to/reject/${id}`;
        const apiUrl = `/zzw-vrm/transfer/to/reject/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    //调入调出   调入：0，调出 1
    async whConfirm(obj: { inAndOut: string, id: string }) {
        // const apiUrl = `/hd-sms/transfer/to/whConfirm`;
        const apiUrl = `/zzw-vrm/transfer/to/whConfirm`;
        return await httpRequest.post<IFmsShopUnitDetail>(apiUrl, obj);
    }

    async export(searchVo: ISCMPurchaseDrSearch) {
        // const apiUrl = "/hd-sms/transfer/to/export";
        const apiUrl = "/zzw-vrm/transfer/to/export";
        return await httpRequest.postFile<boolean>(apiUrl, searchVo, { timeout: 300000 });
    }
    //列表明细导出
    async statisticsExport(searchVo: ISCMPurchaseDrSearch) {
        // const apiUrl = "/hd-sms/transfer/to/statisticsExport";
        const apiUrl = "/zzw-vrm/transfer/to/statisticsExport";
        return await httpRequest.postFile<boolean>(apiUrl, searchVo, { timeout: 300000 });
    }
    async print(id: string) {
        // const apiUrl = `/hd-sms/transfer/to/print/${id}`;
        const apiUrl = `/zzw-vrm/transfer/to/print/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    //调入单明细下载模板
    async downloadTpl() {
        // const appPageUrl = "/hd-sms/transfer/to/detail/downloadTpl";
        const appPageUrl = "/zzw-vrm/transfer/to/detail/downloadTpl";
        return await httpRequest.getFile(appPageUrl);
    }
    //导出调入单明细
    async exportDetail(code: string) {
        // const appPageUrl = `/hd-sms/transfer/to/exportDetails/${code}`;
        const appPageUrl = `/zzw-vrm/transfer/to/exportDetails/${code}`;
        return await httpRequest.getFile(appPageUrl);
    }

    //供应链采购明细查询接口
    async scm2TransferDetails(searchVo: ISCMORVRMTransferSearch) {
        // const apiUrl = "/scm2/purchase/po/transfer/details";
        const apiUrl = "/scm2/inventory/details/page";
        return await httpRequest.post<IPage<ISCMORVRMTransferDetails>>(apiUrl, searchVo);
    }
    //云修采购明细查询接口
    async vrm2TransferDetails(searchVo: ISCMORVRMTransferSearch) {
        const apiUrl = "/zzw-vrm/stock/details/transfer/details";
        return await httpRequest.post<IPage<ISCMORVRMTransferDetails>>(apiUrl, searchVo);
    }
    //客车采购明细查询接口
    async bcmTransferDetails(searchVo: ISCMORVRMTransferSearch) {
        const apiUrl = "/bcm/stock/details/transfer/details";
        return await httpRequest.post<IPage<ISCMORVRMTransferDetails>>(apiUrl, searchVo);
    }
    //云创采购明细查询接口
    async ciTransferDetails(searchVo: ISCMORVRMTransferSearch) {
        const apiUrl = "/ci-storage/stock/details/transfer/details";
        return await httpRequest.post<IPage<ISCMORVRMTransferDetails>>(apiUrl, searchVo, { baseURL: getBaseCiRequestUrl(), token: getToken() });
    }
    //业务系统库房确认接口
    async vrm2WhConfirm(searchVo: ISCMPurchaseDrUpdate) {
        const apiUrl = "/zzw-vrm/stock/details/whConfirm";
        return await httpRequest.post<boolean>(apiUrl, searchVo);
    }
    //查询配件最近仓库货位
    async vrm2StockQuery(searchVo: IVRMQuerySearch) {
        const apiUrl = "/zzw-vrm/stock/details/query";
        return await httpRequest.post<IVRMQueryDetails[]>(apiUrl, searchVo);
    }

    async check(branchIn: string, params: object) {
        const apiUrl = `/zzw-vrm/base/material/checkMaterialExist`
        return await httpRequest.post<any>(apiUrl, params)
    }
    async checkScm(branchIn: string, params: object) {
        const apiUrl = `/zzw-vrm/purchase/po/checkMaterialExist`
        return await httpRequest.post<any>(apiUrl, params)
    }
}

export const purchaseDrService = new PurchaseDrService();